import { render, staticRenderFns } from "./SirketSermaye.vue?vue&type=template&id=4ac3024b&"
import script from "./SirketSermaye.vue?vue&type=script&lang=js&"
export * from "./SirketSermaye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports